import { render, staticRenderFns } from "./packgeItems.vue?vue&type=template&id=97a73178"
import script from "./packgeItems.vue?vue&type=script&lang=js"
export * from "./packgeItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports